export const API_URL = {
  // ------ START: Auth URL's ------
  sendOtp: '/auth/otp/send',
  otpVerify: '/auth/otp/verify',
  refreshToken: '/auth/token/refresh',
  // getMe: "/auth/me", // Removed - no longer used

  // Multi-organization login (app service)
  myOrganizations: '/my-organizations',
  selectOrganization: '/select-organization',
  switchOrganization: '/switch-organization',
  logoutSession: '/logout-session',

  // TODO: OLD DATA
  signin: '/authentication-service/v1/login',
  // getMe: "/auth/v1/profile/get-me",
  uploadFile: '/auth/v1/upload-file',
  uploadMobileToken: '/auth/v1/profile/update-mobile-token',

  // ------ START: Employee Dashboard URL's ------
  employees: '/employees',
  departments: '/departments',
  designations: '/designations',
  dashboard: '/dashboard',
  auditLogs: '/audit-logs',
  // ------ END: Employee Dashboard URL's ------

  // ------ START: Employee Payroll URL's ------
  salaryStructure: '/payroll/salary-structure',
  salaryGrade: '/payroll/salary-grade',
  payrollCalendar: '/payroll-calendar',
  payrollBatch: '/payroll/batch',
  generateSalary: '/payroll/generate',
  payrollBulkImport: '/payroll/bulk-import',
  updateBonusDeduction: '/payroll/history/update-component',
  payrollAdjustments: '/payroll/adjustment',
  generateSalarySheet: '/payroll/history/generate-sheet',
  updatePaymentStatus: '/payroll/history/payment-status',
  generateLeaveEncashment: '/leave-encashment/generate-batch',
  encashmentBatch: '/leave-encashment/batches',
  disburseEncashment: '/leave-encashment/disburse',
  fiscalYears: '/leave-encashment/fiscal-years',
  disbursableEmployees: '/leave-encashment/batches',
  bonusPolicy: '/bonus/policies',
  disburseBonus: '/bonus/disburse',
  generateBankListReport: '/reports/generate-report/payroll/bank-list',
  recruitmentManualShortlist:'/recruitment/shortlist/manual-shortlist',
  // ------ END: Employee Payroll URL's ------

  // ------ START: Employee Attendance URL's ------
  shifts: '/shifts',
  attendance: '/attendance',
  // ------ END: Employee Attendance URL's ------

  // ------ START: Organization URL's ------
  offices: 'offices',
  customEmployeeFields: '/employee-custom-fields',
  organizations: '/hrx/organizations',
  industries: '/hrx/industries',
  plans: '/hrx/plans',
  subscriptions: '/hrx/subscriptions',
  subscriptionVerification: '/hrx/subscription-verification',
  subscriptionByAdminId: '/hrx/subscriptions/by-admin',
  subscriptionByUserId: '/hrx/subscriptions/by-user',
  proceedToPayment: '/hrx/payments/checkout',
  // ------ END: Organization URL's ------

  // ------ START: Leave Dashboard URL's ------
  leave: '/leave-type',
  leaveApplications: '/leave-applications',
  holidays: '/holidays',
  // ------ END: Leave Dashboard URL's ------

  // ------ START: Policies URL's ------
  policies: '/leave-type/policy',
  overtimePolicy: '/overtime-policy',
  // ------ END: Policies URL's ------

  // ------ START: Role Permission URL's ------
  roles: '/roles',
  bulkAssignRoles: '/roles/bulk/assign',
  getRoleUsers: '/roles/role',
  // ------ END: Role Permission URL's ------

  // ------ START: Recruitment URL's ------
  recruitmentJobs: '/recruitment/jobs',
  syncJobStatus: '/recruitment/jobs/sync-job-status',
  recruitmentApplicants: '/recruitment/job-applicants',
  recruitmentShortlist: '/recruitment/shortlist',
  recruitmentCVProcessing: '/recruitment/shortlist/cv-processing',
  recruitmentAnalyzeCvAi: '/recruitment/shortlist/analyze-cv-ai',
  recruitmentCvAnalysisDetails: '/recruitment/shortlist/cv-analysis-details',
  recruitmentAssessments: '/recruitment/assessments',
  recruitmentAssessmentAssign: '/recruitment/assessment-assign',
  recruitmentEvaluatorAssessments:
    '/recruitment/evaluator/assessments/submissions',
  recruitmentEvaluatorInterviews:
    '/recruitment/evaluator/interview/submissions',
  talentHuntJob: '/recruitment/talent-hunt/jobs',
  talentHuntSendEmails: '/recruitment/talent-hunt/send-emails',
  interviewAssign: '/recruitment/interview-assign',
  recruitmentOfferLetter: '/recruitment/offer-letter',
  recruitmentBulkHiringStatus: '/recruitment/offer-letter/bulk-hiring-status',
  recruitmentApplicantRedList: '/recruitment/applicant-red-list',
  recruitmentDashboardStats: '/dashboard/recruitment-stats',
  recruitmentApplicationTrends:
    '/dashboard/recruitment-shortlisted-hired-monthly',
  recruitmentDailyApplicationTrends:
    '/dashboard/recruitment-shortlisted-hired-daily',
  aiCredits: '/credit/organization',
  aiCreditsSummary: '/credit/organization',
  // ------ END: Recruitment URL's ------

  // ------ START: Employee Attendance Report URL's ------
  reports: '/reports',
  // ------ END: Employee Attendance Report URL's ------
  // ------ START: Performance URL's ------
  performanceAdminPlans: '/performance/admin/plans',
  performanceAdminPlan: '/performance/admin/plan',
  performanceEmployeeDraftKPI: '/performance/employee/kpi/draft',
  performanceEmployeeSubmitKPI: '/performance/employee/kpi/submit',
  performanceEmployeeKPIs: '/performance/employee/kpis',
  performanceEmployeeKPI: '/performance/employee/kpi',
  performanceLogView: '/performance/log-view',
  performanceManagerKPIs: '/performance/manager/kpis',
  performanceManagerKPI: '/performance/manager/kpi',
  performanceManagerDraftKPI: '/performance/manager/kpi/draft',
  performanceManagerSubmitKPI: '/performance/manager/kpi/submit',
  performanceManagerReturnKPI: '/performance/manager/kpi/return',
  performanceManagerBulkApproveKPI: '/performance/manager/kpi/bulk-approve',
  performanceEmployeeDraftAppraisal: '/performance/employee/appraisal/draft',
  performanceEmployeeSubmitAppraisal: '/performance/employee/appraisal/submit',
  performanceEmployeeAppraisals: '/performance/employee/appraisals',
  performanceEmployeeAppraisal: '/performance/employee/appraisal',
  performanceManagerDraftAppraisal: '/performance/manager/appraisal/draft',
  performanceManagerSubmitAppraisal: '/performance/manager/appraisal/submit',
  performanceManagerAppraisals: '/performance/manager/appraisals',
  performanceManagerAppraisal: '/performance/manager/appraisal',
  performanceAdminDraftAppraisal: '/performance/admin/appraisal/draft',
  performanceAdminSubmitAppraisal: '/performance/admin/appraisal/submit',
  performanceAdminAppraisals: '/performance/admin/appraisals',
  performanceAdminAppraisal: '/performance/admin/appraisal',
  performanceAdminAppraisalDueDate: '/performance/admin/appraisal/due-date',
  performanceAdminKPIs: '/performance/admin/kpis',
  performanceAdminKPI: '/performance/admin/kpi',
  performanceAdminDashboardGraphs: '/performance/admin/dashboard',
  // ------ END: Performance URL's ------
};
